import { z } from "zod";

export const InvoiceLineSchema = z.object({
  lineNumber: z.number(),
  amount: z.number(),
  quantity: z.number(),
  unitPrice: z.number(),
  itemDescription: z.string(),
});

export const InvoiceSchema = z.object({
  docNumber: z.string(),
  shipAddr: z.object({
    Line1: z.string(),
    City: z.string(),
    Country: z.string(),
    PostalCode: z.string(),
  }),
  billAddr: z.object({
    Line1: z.string(),
    City: z.string(),
    Country: z.string(),
    PostalCode: z.string(),
  }),
  dueDate: z.string(),
  paid: z.boolean(),
  deliveryStatus: z.boolean().optional(),
  deliveryTime: z.string().optional(),
  expectedDeliveryAt: z.string().nullable().catch(null),
  lines: z.array(InvoiceLineSchema),
  trackingNumbers: z.array(z.string()),
});

export type InvoiceLine = z.infer<typeof InvoiceLineSchema>;
export type Invoice = z.infer<typeof InvoiceSchema>;

export type InvoiceDeliveryState = {
  delivered: boolean;
  deliveredAt?: string;
};

export const getInvoiceDeliveryState = (
  invoice: Pick<Invoice, "deliveryStatus" | "deliveryTime">,
): InvoiceDeliveryState =>
  invoice.deliveryTime
    ? { delivered: true, deliveredAt: invoice.deliveryTime }
    : { delivered: invoice.deliveryStatus === true };
